<template>
	<div id="footer-container" v-if="showAnyFooter">
		<AppDefaultFooter :hydrate-on-visible="{ rootMargin: '100px 0px 0px 0px' }" />
		<AppFooterEuropeanBanner v-if="showEuropeanFooterBanner" :hydrate-on-visible="{ rootMargin: '250px' }" />
	</div>
</template>

<script setup lang="ts">
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';

import { useUserStore } from '@/stores/pinia/useUserStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

const AppDefaultFooter = defineLazyHydrationComponent(
	'visible',
	() => import('@/components/footer/AppDefaultFooter.vue')
);
const AppFooterEuropeanBanner = defineLazyHydrationComponent(
	'visible',
	() => import('@/components/footer/AppFooterEuropeanBanner.vue')
);

const route = useRoute();
const languageStore = useLanguageStore();
const userStore = useUserStore();

const showAnyFooter = computed(() => !COUNTRY_WITHOUT_TITLEDETAIL.includes(languageStore.webLocale));

const showEuropeanFooterBanner = computed(() => route.name === 'app.home' && !userStore.isUserOnboarded);
</script>
